<template>
  <a
    v-if="recommendation?.primaryTarget.available && recommendation.primaryTarget.url"
    :href="recommendation.primaryTarget.url"
    target="_blank"
    rel="noopener noreferrer"
    class="brand-link"
    @click="recordWebsiteClick"
  ><slot>职卫云官网</slot></a>
  <span v-else class="brand-link unavailable" aria-live="polite"><slot>职卫云官网</slot></span>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import type { Recommendation, SourceSurface } from '@/types/recommendation'
import { recordRecommendationEvent, resolvePublicRecommendationCached } from '@/utils/recommendations'

const props = defineProps<{ surface: Extract<SourceSurface, 'navbarBrand' | 'footer'> }>()
const recommendation = ref<Recommendation | null>(null)

onMounted(async () => {
  try {
    recommendation.value = await resolvePublicRecommendationCached(props.surface)
    if (recommendation.value) {
      await recordRecommendationEvent(recommendation.value, 'recommendationImpression', 'unit')
    }
  } catch (error) {
    console.warn('职卫云品牌入口加载失败，不影响题库功能', error)
  }
})

const recordWebsiteClick = () => {
  const current = recommendation.value
  if (!current?.primaryTarget.url) return
  void recordRecommendationEvent(current, 'recommendationClick', 'primary').catch((error) => {
    console.warn('品牌入口点击记录失败', error)
  })
}
</script>

<style scoped>
.brand-link { color: inherit; text-decoration: underline; text-underline-offset: 3px; white-space: nowrap; }
.unavailable { opacity: .72; text-decoration: none; }
</style>
